import * as React from 'react';
import { CategoryData } from '../App';
import { CategoryName, DescriptionBottom, TemplateHero, TemplateHeroOffset, GalleryTabsContainer, GalleryTab } from '../styles/CategoryHeader';

interface TemplateProps {
    category: CategoryData;
    headerColor?: string;
    activeGalleryTab?: string;
    presentationsTabString?: string;
    videosTabString?: string;
    designTabString?: string;
    isUseAsTemplateFlowActive?: boolean;
    templateFlowPageTitleString?: string;
}


export class CategoryHeader extends React.Component<TemplateProps, any> {

    constructor(props: TemplateProps) {
        super(props);
    }

    render() {
        const shouldDisplayTemplateFlowTitle = this.props.category.slug == "/" && this.props.isUseAsTemplateFlowActive;
        const templateOffsetClasses = this.props.category.element_id ?
            `col-xs-12 cms-prezi-plugin-edit cms-plugin cms-plugin-${this.props.category.element_id}` : 'col-xs-12';
        return (
            <section>
                <div className={ 'container' }>
                    <div className={ 'row' }>
                        <TemplateHeroOffset className={ templateOffsetClasses }>
                            <TemplateHero headerColor={ this.props.headerColor } key={ this.props.category.slug }>
                                <div className={ 'col-xs-12 pad-zero' }>
                                    <div>
                                        <CategoryName className={ 'btm-18' }>
                                            {shouldDisplayTemplateFlowTitle
                                                ? this.props.templateFlowPageTitleString
                                                : this.props.category.name
                                            }
                                        </CategoryName>
                                        <DescriptionBottom className={ 'col-xs-12 col-lg-7 pad-zero' }>
                                            { this.props.category.description }
                                        </DescriptionBottom>
                                    </div>
                                </div>
                            </TemplateHero>
                        </TemplateHeroOffset>
                    </div>

                    { this.props.activeGalleryTab && (
                    <GalleryTabsContainer>
                        <GalleryTab
                            className={this.props.activeGalleryTab == 'present' ? 'active': ''}
                            href="/gallery/"
                        >
                            { this.props.presentationsTabString }
                        </GalleryTab>
                        <GalleryTab 
                            href="/video/explore/"
                        >
                            { this.props.videosTabString }
                        </GalleryTab>
                        <GalleryTab
                            className={this.props.activeGalleryTab == 'design' ? 'active': ''} 
                            href="/design/gallery/"
                        >
                            { this.props.designTabString }
                        </GalleryTab>
                    </GalleryTabsContainer>
                    )}
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/CategoryHeader.tsx